import axios from 'axios'
import { menuItemActual } from '../utils/menuItem'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
})

api.interceptors.request.use((config) => {
  // Un FormData (subida de archivo) NO puede viajar con el Content-Type JSON
  // del default de arriba: axios 1.x, al ver ese header, serializa el FormData
  // a JSON y el archivo se pierde en el camino — el backend responde "The
  // imagen field is required" y parece que la foto es obligatoria (incidente
  // 26 ago 2026, alta de experiencia: ninguna foto entró jamás). Con
  // multipart, axios pone el boundary correcto solo.
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data'
  }
  const token = localStorage.getItem('lgr_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // Segundo factor: "Confiar en este dispositivo por 30 días" guardó un token
  // en este navegador; /login lo manda para saltear el código mientras dure.
  if (config.url === '/login') {
    const dispositivo = localStorage.getItem('lgr_dispositivo')
    if (dispositivo) config.headers['X-Dispositivo-Confiable'] = dispositivo
  }
  // Permisos por PERSONA: de qué ítem del menú sale el pedido (el backend
  // rechaza los de un ítem restringido si la persona no está en su lista).
  const item = menuItemActual()
  if (item) config.headers['X-Menu-Item'] = item
  // Imitación del Super Administrador (el backend solo la respeta si sos
  // super-admin): "ver como" un USUARIO puntual manda sobre "ver como" un rol.
  const impUser = localStorage.getItem('lgr_impersonate_user')
  const imp = localStorage.getItem('lgr_impersonate')
  if (impUser) {
    try { config.headers['X-Impersonate-User'] = JSON.parse(impUser).id } catch { /* valor roto: se ignora */ }
  } else if (imp) {
    config.headers['X-Impersonate-Role'] = imp
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('lgr_token')
      localStorage.removeItem('lgr_user')
      window.location.href = '/login'
    }
    // El rol exige el segundo factor y todavía no está activado: el backend
    // cierra todo menos /me, /logout y /totp/*. A activarlo.
    // Pantalla restringida a otras personas: avisa a Layout para mostrar "No tenés acceso".
    if (error.response?.status === 403 && error.response?.data?.code === 'sin_acceso_persona') {
      window.dispatchEvent(new CustomEvent('lgr:sin-acceso'))
    }
    if (error.response?.status === 403 && error.response?.data?.code === 'totp_requerido'
      && window.location.pathname !== '/seguridad') {
      window.location.href = '/seguridad'
    }
    return Promise.reject(error)
  }
)

export default api
